/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('change', function (event) {
  var linkedProductSelect = event.target.closest('[data-linked-product-select]');

  if (linkedProductSelect && linkedProductSelect.value) {
    window.location.assign(linkedProductSelect.value);
  }
});

/**
 * Product shipping countdown in Europe/Amsterdam time.
 * Skips weekends and the commonly observed Dutch public holidays.
 */
(function () {
  var AMSTERDAM_TIME_ZONE = 'Europe/Amsterdam';
  var DAY_NAMES = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];
  var MONTH_NAMES = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  function pad(number) {
    return String(number).padStart(2, '0');
  }

  function dateKey(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function addDays(date, days) {
    var result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + days);
    return result;
  }

  function easterSunday(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(Date.UTC(year, month - 1, day));
  }

  function dutchHolidayKeys(year) {
    var easter = easterSunday(year);
    var kingsDay = new Date(Date.UTC(year, 3, 27));

    if (kingsDay.getUTCDay() === 0) {
      kingsDay = new Date(Date.UTC(year, 3, 26));
    }

    return new Set([
      dateKey(new Date(Date.UTC(year, 0, 1))),
      dateKey(addDays(easter, -2)),
      dateKey(easter),
      dateKey(addDays(easter, 1)),
      dateKey(kingsDay),
      dateKey(new Date(Date.UTC(year, 4, 5))),
      dateKey(addDays(easter, 39)),
      dateKey(addDays(easter, 49)),
      dateKey(addDays(easter, 50)),
      dateKey(new Date(Date.UTC(year, 11, 25))),
      dateKey(new Date(Date.UTC(year, 11, 26)))
    ]);
  }

  function amsterdamParts(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: AMSTERDAM_TIME_ZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') {
        values[part.type] = Number(part.value);
      }
    });

    return values;
  }

  function amsterdamDateTimeToUtc(year, month, day, hour, minute, second) {
    var desiredAsUtc = Date.UTC(year, month - 1, day, hour, minute, second || 0);
    var guess = desiredAsUtc;

    for (var attempt = 0; attempt < 3; attempt += 1) {
      var actual = amsterdamParts(new Date(guess));
      var actualAsUtc = Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute, actual.second);
      guess += desiredAsUtc - actualAsUtc;
    }

    return new Date(guess);
  }

  function isShippingDay(date, skipHolidays) {
    var day = date.getUTCDay();

    if (day === 0 || day === 6) {
      return false;
    }

    return !skipHolidays || !dutchHolidayKeys(date.getUTCFullYear()).has(dateKey(date));
  }

  function nextShippingDay(date, skipHolidays) {
    var candidate = addDays(date, 1);

    while (!isShippingDay(candidate, skipHolidays)) {
      candidate = addDays(candidate, 1);
    }

    return candidate;
  }

  function readableDate(date) {
    return DAY_NAMES[date.getUTCDay()] + ' ' + date.getUTCDate() + ' ' + MONTH_NAMES[date.getUTCMonth()];
  }

  function initializeShippingCountdown(element) {
    if (element.dataset.shippingCountdownInitialized === 'true') {
      return;
    }

    element.dataset.shippingCountdownInitialized = 'true';
    var title = element.querySelector('[data-shipping-countdown-title]');
    var message = element.querySelector('[data-shipping-countdown-message]');
    var cutoffParts = (element.dataset.cutoff || '16:30').split(':');
    var cutoffHour = Number(cutoffParts[0]);
    var cutoffMinute = Number(cutoffParts[1]);
    var skipHolidays = element.dataset.skipHolidays !== 'false';

    if (!Number.isFinite(cutoffHour) || !Number.isFinite(cutoffMinute)) {
      cutoffHour = 16;
      cutoffMinute = 30;
    }

    function update() {
      var now = new Date();
      var local = amsterdamParts(now);
      var localDate = new Date(Date.UTC(local.year, local.month - 1, local.day));
      var cutoff = amsterdamDateTimeToUtc(local.year, local.month, local.day, cutoffHour, cutoffMinute, 0);

      if (isShippingDay(localDate, skipHolidays) && now < cutoff) {
        var remainingSeconds = Math.max(0, Math.floor((cutoff.getTime() - now.getTime()) / 1000));
        var hours = Math.floor(remainingSeconds / 3600);
        var minutes = Math.floor((remainingSeconds % 3600) / 60);
        var seconds = remainingSeconds % 60;

        title.textContent = 'Vandaag verzonden';
        message.innerHTML = 'Bestel binnen <span class="shipping-countdown__timer">' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds) + '</span> en betaal voor ' + pad(cutoffHour) + ':' + pad(cutoffMinute) + ' uur.';
      } else {
        var shippingDate = nextShippingDay(localDate, skipHolidays);
        title.textContent = 'Eerstvolgende verzending: ' + readableDate(shippingDate);
        message.textContent = 'Bestel nu, dan wordt je bestelling ' + DAY_NAMES[shippingDate.getUTCDay()] + ' verzonden.';
      }
    }

    update();
    window.setInterval(update, 1000);
  }

  function initializeAllShippingCountdowns() {
    document.querySelectorAll('[data-shipping-countdown]').forEach(initializeShippingCountdown);
  }

  document.addEventListener('DOMContentLoaded', initializeAllShippingCountdowns);
  document.addEventListener('shopify:section:load', initializeAllShippingCountdowns);
  document.addEventListener('variant:changed', function () {
    window.setTimeout(initializeAllShippingCountdowns, 0);
  });
})();

/**
 * Make single-word searches include word variations, while keeping multi-word
 * searches strict so Shopify does not return products matching only one word.
 */
function buildStrictSearchQuery(query) {
  var terms = query.match(/"[^"]+"|\S+/g) || [];
  var containsSearchSyntax = terms.some(function (term) {
    return /^(AND|OR|NOT)$/i.test(term) || /[:()]/.test(term);
  });

  if (containsSearchSyntax) {
    return query;
  }

  if (terms.length === 1) {
    return terms[0].replace(/\*+$/, '') + '*';
  }

  return terms.join(' AND ');
}

function redirectToStrictSearch(searchInput, event) {
  var query = searchInput.value.trim();

  if (!query) {
    return;
  }

  event.preventDefault();

  var searchForm = searchInput.closest('form');
  var productTypeSelect = searchForm ? searchForm.querySelector('#search-product-type') : null;
  var productType = productTypeSelect ? productTypeSelect.value : '';
  var searchUrl = window.routes && window.routes.searchUrl ? window.routes.searchUrl : '/search';
  var params = new URLSearchParams();
  var strictQuery = buildStrictSearchQuery(query);

  params.set('q', productType ? 'product_type:' + productType + ' AND ' + strictQuery : strictQuery);
  params.set('type', 'product');
  params.set('options[prefix]', 'last');
  window.location.assign(searchUrl + '?' + params.toString());
}

document.addEventListener('keydown', function (event) {
  var searchInput = event.target.closest('.search-bar__input');

  if (!searchInput || event.key !== 'Enter' || event.isComposing) {
    return;
  }

  redirectToStrictSearch(searchInput, event);
});

document.addEventListener('submit', function (event) {
  var searchForm = event.target;
  var searchInput = searchForm.querySelector('.search-bar__input');

  if (!searchInput) {
    return;
  }

  redirectToStrictSearch(searchInput, event);
});

/**
 * Repair invalid rich-text lists where text was pasted directly inside a UL/OL
 * instead of being wrapped in an LI. This preserves links and inline formatting.
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.rte ul, .rte ol').forEach(function (list) {
    var pendingNodes = [];

    function flushPendingNodes(beforeNode) {
      var hasContent = pendingNodes.some(function (node) {
        return node.nodeType !== Node.TEXT_NODE || node.textContent.trim() !== '';
      });

      if (hasContent) {
        var listItem = document.createElement('li');
        list.insertBefore(listItem, beforeNode || null);

        pendingNodes.forEach(function (node) {
          listItem.appendChild(node);
        });
      }

      pendingNodes = [];
    }

    Array.from(list.childNodes).forEach(function (node) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'LI') {
        flushPendingNodes(node);
      } else {
        pendingNodes.push(node);
      }
    });

    flushPendingNodes(null);
  });
});

/**
 * Mobile sticky add-to-cart.
 * It delegates to the theme's real product button so cart updates, validation
 * and Shopify's normal product-form events keep working unchanged.
 */
function initializeMobileStickyCart() {
  var stickyCart = document.querySelector('[data-mobile-sticky-cart]');
  var stickyButton = stickyCart && stickyCart.querySelector('[data-mobile-sticky-cart-button]');

  if (!stickyCart || !stickyButton || stickyCart.dataset.mobileStickyCartInitialized === 'true') {
    return;
  }

  stickyCart.dataset.mobileStickyCartInitialized = 'true';
  var visibilityObserver = null;
  var buttonObserver = null;
  var miniCart = document.getElementById('mini-cart');

  function getOriginalButton() {
    return document.querySelector('form[id^="product-form-main-"] .product-form__add-button');
  }

  function syncStickyButton() {
    var originalButton = getOriginalButton();

    if (!originalButton) {
      stickyCart.hidden = true;
      return;
    }

    stickyCart.hidden = false;
    stickyButton.disabled = originalButton.disabled;
    stickyButton.textContent = originalButton.textContent.trim();
  }

  function observeOriginalButton() {
    var originalButton = getOriginalButton();

    if (visibilityObserver) {
      visibilityObserver.disconnect();
    }

    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    if (originalButton && 'IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver(function (entries) {
        stickyCart.classList.toggle('is-original-visible', entries[0].isIntersecting);
      }, { threshold: 0.25 });
      visibilityObserver.observe(originalButton);
    }

    if (originalButton && 'MutationObserver' in window) {
      buttonObserver = new MutationObserver(syncStickyButton);
      buttonObserver.observe(originalButton, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    syncStickyButton();
  }

  function refreshAfterRerender() {
    window.setTimeout(function () {
      observeOriginalButton();
      initializeMobileStickyCart();
    }, 0);
  }

  function syncMiniCartState() {
    stickyCart.classList.toggle(
      'is-overlay-open',
      miniCart && miniCart.getAttribute('aria-hidden') === 'false'
    );
  }

  stickyButton.addEventListener('click', function () {
    var originalButton = getOriginalButton();

    if (originalButton && !originalButton.disabled) {
      originalButton.click();
    }
  });

  var productForm = stickyCart.closest('product-rerender');
  productForm = productForm && productForm.querySelector('form[id^="product-form-main-"]');

  if (productForm) {
    productForm.addEventListener('product:rerender', refreshAfterRerender);
    productForm.addEventListener('variant:changed', refreshAfterRerender);
  }

  if (miniCart && 'MutationObserver' in window) {
    new MutationObserver(syncMiniCartState).observe(miniCart, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  syncMiniCartState();
  observeOriginalButton();
}

document.addEventListener('DOMContentLoaded', initializeMobileStickyCart);

/**
 * Keep the cart toggle's accessible name in sync with the visible item count.
 */
function initializeAccessibleCartLabel() {
  var cartToggle = document.querySelector('.header__cart-toggle');
  var cartCount = cartToggle && cartToggle.querySelector('.header__cart-count');

  if (!cartToggle || !cartCount) {
    return;
  }

  function updateCartLabel() {
    var itemCount = Number.parseInt(cartCount.textContent, 10) || 0;
    var countLabel = itemCount === 0 ? 'leeg' : itemCount === 1 ? '1 artikel' : itemCount + ' artikelen';

    cartToggle.setAttribute('aria-label', 'Winkelwagen, ' + countLabel);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(updateCartLabel).observe(cartCount, {
      characterData: true,
      childList: true,
      subtree: true
    });
  }

  updateCartLabel();
}

document.addEventListener('DOMContentLoaded', initializeAccessibleCartLabel);
